/* eslint-disable @typescript-eslint/naming-convention */
export enum FormMode {
  create,
  edit,
  view,
}
